import React, { useEffect } from 'react'
import PropTypes from 'prop-types'
import Wizard from 'core/components/wizard'
import wizardsShape from 'core/components/wizard/shapes'
import aSteps from './steps'

const Stock = props => {
  const { setWizards, wizards } = props
  // resetStockWizard
  const { aStepsStock } = wizards

  const aStepsActive = wizards.aStepsStock

  useEffect(() => {
    const extendedAStepsStock = aSteps.map(
      item => aStepsStock.filter(step => step.hash === item.hash)[0]
    )

    const extendedWizard = {
      ...wizards,
      activeWizard: 'aStepsStock',
      aStepsStock: extendedAStepsStock
    }
    setWizards(extendedWizard)
    //resetStockWizard()
  }, [])

  return <Wizard aSteps={aSteps} aStepsActive={aStepsActive} data-test="component-stock" />
}

Stock.propTypes = {
  setWizards: PropTypes.func.isRequired,
  //resetStockWizard: PropTypes.func.isRequired,
  wizards: wizardsShape.isRequired
}

export default Stock
